module.exports = __webpack_public_path__ + "img/img10.a71cdecc.png";